var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFollowingRound = function SvgFollowingRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "#FCFCFF",
    stroke: "#DDDFE5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#following-round_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#following-round_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#following-round_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A35",
    d: "M13 19.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5Zm0-6c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5Zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5Zm4 2.5h12c.55 0 1-.45 1-1s-.45-1-1-1H17c-.55 0-1 .45-1 1s.45 1 1 1Zm0-6h12c.55 0 1-.45 1-1s-.45-1-1-1H17c-.55 0-1 .45-1 1s.45 1 1 1Zm-1-7c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H17c-.55 0-1 .45-1 1Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "following-round_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h24v24H9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "following-round_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h24v24H9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "following-round_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h24v24H9z"
  })))));
};
export default SvgFollowingRound;